import { useQuery } from "react-query";
import { Get } from "../utils/api";
import { useAuth0 } from "@auth0/auth0-react";
import { OrganizationOnboardingStatus } from "../../types/api/Organization";

export default (orgId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery<OrganizationOnboardingStatus>(
    `onboarding_status_${orgId}`,
    async () => {
      return await Get<OrganizationOnboardingStatus>(
        `/api/organization/${orgId}/onboarding/status`,
        await getAccessTokenSilently()
      );
    }
  );
};
